"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_router_dom_1 = require("react-router-dom");

var react_jss_1 = __importDefault(require("react-jss"));

var BurnerProvider_1 = require("../../BurnerProvider");

var AddressInputField_1 = __importDefault(require("../../components/AddressInputField"));

var AddressInputSearchResults_1 = __importDefault(require("../../components/AddressInputSearchResults"));

var AssetSelector_1 = __importDefault(require("../../components/AssetSelector"));

var AmountInput_1 = __importDefault(require("../../components/AmountInput"));

var Button_1 = __importDefault(require("../../components/Button"));

var Page_1 = __importDefault(require("../../components/Page"));

var styles = {
  messageField: {
    width: '100%',
    padding: 4,
    fontSize: 16,
    background: '#EEEEEE',
    height: 40,
    boxSizing: 'border-box',
    border: 'solid 1px #cccccc',
    borderRadius: 4
  },
  sendContainer: {
    marginTop: 16
  }
};

var SendPage =
/** @class */
function (_super) {
  __extends(SendPage, _super);

  function SendPage(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      to: props.location.state && props.location.state.address || '',
      value: '',
      message: '',
      asset: null,
      sending: false,
      txHash: null,
      account: null,
      accounts: []
    };
    return _this;
  }

  SendPage.prototype.getAccounts = function (search) {
    return __awaiter(this, void 0, void 0, function () {
      var pluginData, _accounts, accounts;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            pluginData = this.props.pluginData;
            return [4
            /*yield*/
            , Promise.all(pluginData.accountSearches.map(function (searchFn) {
              return searchFn(search);
            }))];

          case 1:
            _accounts = _b.sent();
            accounts = (_a = Array.prototype).concat.apply(_a, _accounts);
            this.setState({
              accounts: accounts
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  SendPage.prototype.scanCode = function () {
    return __awaiter(this, void 0, void 0, function () {
      var address, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this.props.actions.scanQrCode()];

          case 1:
            address = _a.sent();
            this.setState({
              to: address
            });
            return [3
            /*break*/
            , 3];

          case 2:
            e_1 = _a.sent();
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  SendPage.prototype.send = function () {
    var _a = this.state,
        asset = _a.asset,
        to = _a.to,
        value = _a.value,
        message = _a.message;
    var _b = this.props,
        accounts = _b.accounts,
        actions = _b.actions;

    if (!asset) {
      throw new Error('Asset not selected');
    }

    actions.send({
      from: accounts[0],
      to: to,
      ether: value,
      asset: asset.id,
      message: message.length > 0 ? message : null
    });
  };

  SendPage.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        to = _a.to,
        value = _a.value,
        asset = _a.asset,
        sending = _a.sending,
        txHash = _a.txHash,
        account = _a.account,
        accounts = _a.accounts,
        message = _a.message;
    var _b = this.props,
        actions = _b.actions,
        classes = _b.classes;

    if (txHash && asset) {
      return react_1.default.createElement(react_router_dom_1.Redirect, {
        to: "/receipt/" + asset.id + "/" + txHash
      });
    }

    var canSend = asset !== null && !sending && to.length == 42 && to;
    return react_1.default.createElement(Page_1.default, {
      title: "Send To Address"
    }, react_1.default.createElement(AssetSelector_1.default, {
      selected: asset,
      onChange: function onChange(newAsset) {
        return _this.setState({
          asset: newAsset
        });
      },
      disabled: sending
    }), react_1.default.createElement("div", null, "To address:"), react_1.default.createElement(AddressInputField_1.default, {
      value: to,
      account: account,
      onChange: function onChange(to, account) {
        _this.setState({
          to: to,
          account: account
        });

        if (account) {
          _this.setState({
            accounts: []
          });
        } else {
          _this.getAccounts(to);
        }
      },
      scan: function scan() {
        return _this.scanCode();
      },
      disabled: sending
    }), react_1.default.createElement(AddressInputSearchResults_1.default, {
      accounts: accounts,
      onSelect: function onSelect(account) {
        return _this.setState({
          account: account,
          accounts: []
        });
      }
    }), react_1.default.createElement("div", null, "Send Amount:"), react_1.default.createElement(AmountInput_1.default, {
      asset: asset,
      value: value,
      onChange: function onChange(e) {
        return _this.setState({
          value: e.target.value
        });
      },
      disabled: sending
    }), asset && asset.supportsMessages() && react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement("div", null, "Message:"), react_1.default.createElement("input", {
      value: message,
      onChange: function onChange(e) {
        return _this.setState({
          message: e.target.value
        });
      },
      className: classes.messageField
    })), react_1.default.createElement("div", {
      className: classes.sendContainer
    }, react_1.default.createElement(Button_1.default, {
      onClick: function onClick() {
        return _this.send();
      },
      disabled: !canSend
    }, "Send")));
  };

  return SendPage;
}(react_1.Component);

exports.default = react_jss_1.default(styles)(BurnerProvider_1.withBurner(SendPage));